<template>
  <div class="course-list-comp">
    <div class="card-list" v-if="items.length">
      <course-overview-card-comp
        v-for="(course, index) in items"
        :key="index"
        :mall-course="course"
        type="order"
      ></course-overview-card-comp>
    </div>
    <p-e-empty-info v-else tip="没有课程订单"></p-e-empty-info>
  </div>
</template>
<script lang="ts">
import { BaseComponent, Component } from 'kuaidong-component'
import CourseOverviewCardComp from '@/views/my-gift/components/CourseOverviewCard.vue'
import PEEmptyInfo from '@/views/pe-class/components/PEEmptyInfo.vue'
import { IMallCourseOrderList } from 'kuaidong-model'
import { ACourseCenter } from 'kuaidong-api'
@Component({
  components: {
    CourseOverviewCardComp,
    PEEmptyInfo,
  },
})
export default class CourseListComp extends BaseComponent {
  courseList: IMallCourseOrderList | null = null

  get items() {
    return this.courseList ? this.courseList.items : []
  }

  async created() {
    this.fetchCourseOrderList()
  }

  async fetchCourseOrderList() {
    this.courseList = await ACourseCenter.orderList()
  }
}
</script>
<style lang="less">
.course-list-comp {
  margin-top: 16px;
  > .card-list {
    > .course-overview-card-comp {
      margin-top: 16px;
    }
  }
  > .pe-empty-comp {
    margin-top: 133px;
  }
}
</style>
